import { Component, EventEmitter, Input, Output } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SuggestionsService } from '../../patients/subscription-suggestions/suggestions.service';
import { SubscriptionOrderSuggestion } from '../../patients/subscription-suggestions/models/suggestion.model';

@Component({
  standalone: false,
  selector: 'app-subscription-suggestion-banner',
  templateUrl: './subscription-suggestion-banner.component.html',
  styleUrls: ['./subscription-suggestion-banner.component.scss'],
})
export class SubscriptionSuggestionBannerComponent {
  @Input() suggestions: SubscriptionOrderSuggestion[] = [];
  @Input() resolvedByEmail?: string;
  @Input() compact = false;

  @Output() resolved = new EventEmitter<{ id: string; action: 'applied' | 'dismissed' }>();

  expanded: Record<string, boolean> = {};
  busyId: string | null = null;
  busyAction: 'applying' | 'dismissing' | null = null;
  errorByItem: Record<string, string | undefined> = {};

  constructor(private suggestionsService: SuggestionsService) {}

  trackById(_: number, item: SubscriptionOrderSuggestion): string {
    return item._id;
  }

  toggleReasoning(id: string): void {
    this.expanded[id] = !this.expanded[id];
  }

  shopifyOrderHref(id: number | undefined): string | null {
    return id ? `https://admin.shopify.com/store/evinature/orders/${id}` : null;
  }

  async apply(suggestion: SubscriptionOrderSuggestion): Promise<void> {
    if (this.busyId) return;
    this.busyId = suggestion._id;
    this.busyAction = 'applying';
    this.errorByItem[suggestion._id] = undefined;
    try {
      await firstValueFrom(this.suggestionsService.apply(suggestion._id, this.resolvedByEmail));
      this.resolved.emit({ id: suggestion._id, action: 'applied' });
    } catch (err: any) {
      this.errorByItem[suggestion._id] =
        err?.error?.error || err?.message || 'Apply failed';
    } finally {
      this.busyId = null;
      this.busyAction = null;
    }
  }

  async dismiss(suggestion: SubscriptionOrderSuggestion): Promise<void> {
    if (this.busyId) return;
    this.busyId = suggestion._id;
    this.busyAction = 'dismissing';
    this.errorByItem[suggestion._id] = undefined;
    try {
      await firstValueFrom(this.suggestionsService.dismiss(suggestion._id, this.resolvedByEmail));
      this.resolved.emit({ id: suggestion._id, action: 'dismissed' });
    } catch (err: any) {
      this.errorByItem[suggestion._id] =
        err?.error?.error || err?.message || 'Dismiss failed';
    } finally {
      this.busyId = null;
      this.busyAction = null;
    }
  }
}
